/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MinimiseAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Body from 'DesignSystem/Body/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconExpandMore from 'DesignSystem/Svgs/TysiaIconExpandMore/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function MinimiseAction({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Waiting/MinimiseAction",
  isHovered
  
}) {
  let isBefore = useIsBefore()
  let flow = fromFlow.useFlow()
let constantData = ''
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isHovered
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 alignSelf="center"
 size="small"
 marginLeft={4}
 data="''"
 onClick={onClick}
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<div
  data-testid="MinimiseAction.Vertical"
  data-view-path={viewPath}
 style={{'--r-1-ZdVM8j': flow.has(fromFlow.normalizePath(viewPath, '../Appointments/Content')) ? "180deg" : "0deg"}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaIconExpandMore
  viewPath={`${viewPath}/TysiaIconExpandMore`}
 width={16}
 height={16}
/>
</div>
)}
</TysiaButtonIcon>
<fromFlow.When is={childProps.isHovered}>
<div
  data-testid="MinimiseAction.Vertical:1"
  data-view-path={viewPath}
 style={{'--o-3-ZdVM8j': isBefore ? 0 : 1,'--t-2-ZdVM8j': isBefore ? "20px" : "26px"}}
 className={`views-block ${styles.Vertical1}`}
>
<Body
  viewPath={`${viewPath}/Body`}
 fontSize={12}
 text={flow.has(fromFlow.normalizePath(viewPath, '../Appointments/Content')) ? "Minimize" : "Maximize"}
 lineHeight={1}
/>
</div>
</fromFlow.When>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}